export const OneIcon = () => {
  return (
    <svg
      width="27"
      height="46"
      viewBox="0 0 27 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.431 44.1164C26.431 45.0256 25.6228 45.7328 24.8147 45.7328H2.18535C1.27613 45.7328 0.568966 45.0256 0.568966 44.1164C0.568966 43.3082 1.27613 42.5 2.18535 42.5H11.8836V5.22225L6.32732 9.16218C5.51913 9.6673 4.50889 9.46525 4.00377 8.75808C3.49865 7.94989 3.7007 6.93966 4.40787 6.43454L12.4898 0.878234C12.9949 0.575163 13.702 0.474139 14.2072 0.77721C14.7123 0.979258 15.1164 1.5854 15.1164 2.19154V42.5H24.8147C25.6228 42.5 26.431 43.3082 26.431 44.1164Z"
        fill="white"
      />
    </svg>
  );
};
